import type { ReactNode } from 'react';

interface LinksType {
  [key: string]: string | undefined;
}
export interface Link {
  text?: string;
  url?: string;
  external?: boolean;
  dataTestId?: string;
}

export interface CardsDataType {
  id: number;
  title: string;
  icon: ReactNode;
  className: string;
  description: string;
  links: Link[];
  titleElement?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  titleClassName: string;
}

export const ConnectAndEngageLinks: LinksType = {
  ENGAGE_STUDENT_COMMUNITY: process.env.NEXT_PUBLIC_STUDENT_COMMUNITY_LINK,
  COMMUNITY_LINK: 'https://inscribe.education/main/umgc/communities',
  STUDENT_ORGANIZATION: 'https://www.umgc.edu/current-students/student-life-and-support/clubs',
  VOLUNTEER_PLATFORM: 'https://umgc.galaxydigital.com/',
  VOLUNTEER_OF_THE_MONTH:
    'https://www.umgc.edu/current-students/student-life-and-support/volunteer-of-month',
  STAC: 'https://www.umgc.edu/current-students/student-life-and-support/student-advisory-council',
  STIC: 'https://forms.cloud.microsoft/r/TJFR5fjU4p',
  UMGC_STORE: 'http://gear.umgc.edu/',
};

export const ConnectEngageCardsData: CardsDataType[] = [
  {
    id: 0,
    title: 'Connect & Engage',
    icon: undefined,
    className: 'sm:col-span-2 sm:shadow-lg  md:col-span-3',
    titleElement: 'h1',
    titleClassName: 'text-4xl font-normal pb-3',
    description:
      'UMGC has a vibrant, global network of students and alumni and many opportunities where you can meet new people, explore shared interests, and get involved. Building connections can expand your network, open doors to new opportunities, and give you a support system that celebrates your wins and helps you navigate challenges.',
    links: [
      {
        text: '',
        url: '',
      },
    ],
  },
  {
    id: 1,
    title: 'UMGC Student Community',
    icon: <i className="fal fa-people-group text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-2',
    titleClassName: 'text-2xl',
    description:
      'Step into your go-to space for asking questions, trading advice, and celebrating wins together.',
    links: [
      {
        text: 'Engage in the Student Community',
        dataTestId: 'connect-engage-link-engage-student-community',
        url: ConnectAndEngageLinks.ENGAGE_STUDENT_COMMUNITY,
      },
      {
        text: 'Discover communities you can join',
        dataTestId: 'connect-engage-link-discover-communities',
        url: ConnectAndEngageLinks.COMMUNITY_LINK,
      },
    ],
  },
  {
    id: 3,
    title: 'Student Advisory Council (STAC)',
    icon: <i className="fal fa-user-group text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-1',
    titleClassName: 'text-2xl',
    description:
      'Student voices matter here. The Student Advisory Council serves as your student government by representing learners and informing key decisions across UMGC.',
    links: [
      {
        text: 'See How It Works',
        dataTestId: 'connect-engage-link-learn-stac',
        url: ConnectAndEngageLinks?.STAC,
      },
    ],
  },
  {
    id: 2,
    title: 'Student Organizations',
    icon: <i className="fal fa-graduation-cap text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-2',
    titleClassName: 'text-2xl',
    description:
      'Join a club or group to meet like-minded peers, take a leadership role, and make things happen.',
    links: [
      {
        text: 'Visit the Student Organizations',
        dataTestId: 'connect-engage-link-visit-student-organizations',
        url: ConnectAndEngageLinks?.STUDENT_ORGANIZATION,
      },
    ],
  },
  {
    id: 4,
    title: 'Student Insight Council (STIC)',
    icon: <i className="fal fa-volume-high text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-1',
    titleClassName: 'text-2xl',
    description:
      "Shape UMGC's future! The Student Insight Council tests new products, co-designs, serves on panels, and shares their voice via surveys.",
    links: [
      {
        text: 'Sign-up here',
        dataTestId: 'connect-engage-link-signup-stic',
        url: ConnectAndEngageLinks?.STIC,
      },
    ],
  },
  {
    id: 5,
    title: 'Social Media',
    icon: <i className="fal fa-hashtag text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-2',
    titleClassName: 'text-2xl',
    description:
      "Connect with students, alumni, faculty, advisors, and staff across the UMGC community. Stay informed with the latest university news, academic updates, career resources, and events through UMGC's official, moderated social media channels.",
    links: [],
  },
  {
    id: 6,
    title: 'University Store',
    icon: <i className="fal fa-store text-2xl"></i>,
    className: 'sm:shadow-lg md:col-span-1',
    titleClassName: 'text-2xl',
    description: 'Show your UMGC pride with apparel, gifts, and other official merchandise.',
    links: [
      {
        text: 'Visit Store Catalog',
        dataTestId: 'UMGC Gear',
        url: ConnectAndEngageLinks?.UMGC_STORE,
      },
    ],
  },
];

export const embededGuideContainerId = 'embededGuide-container';
